import api from "../../../api/axios";

// Feature-local wrapper for the ClientContact list GET used by the
// /clients/:clientId parent surface (Phase R2).
//
// Endpoint (per backend/app/apps/clients/urls.py ClientContactListCreateView):
//   GET /api/crm/clients/{client_id}/contacts/
//        — IsClientAccessible (owner OR active share).
//        — Returns an array of contact rows ({id, type, value, is_primary, ...}).
//
// Feature-local copy by convention. Phase R2 reads contacts ONLY as
// part of the parent's initial load + manual refresh. No mutation
// surface here — mutations remain at /clients/:id/contacts/edit.
//
// Stateless request wrapper. No cache. No retry. No invalidation.

export const fetchClientContacts = (clientId, { signal } = {}) =>
  api
    .get(`/crm/clients/${clientId}/contacts/`, { signal })
    .then((res) => res.data);
